import {
	ADMINGETKYCACTIONTYPE_SUCCESS,
	ADMINGETKYCACTIONTYPE_FAILED,
	RESET_ADMINGETKYCACTIONTYPE,
	LOADING_ADMINGETKYCACTIONTYPE,
	NETWORK_ERROR_ADMINGETKYCACTIONTYPE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetkycActionType = () => {
	return { type: RESET_ADMINGETKYCACTIONTYPE };
};

const adminGetkycActionType = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETKYCACTIONTYPE });
	await adminServices
		.post("getKycActionTypeList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetkycActionTypesuccess(res.data));
					break;
				default:
					dispatch(adminGetkycActionTypeFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETKYCACTIONTYPE,
				payload: err
			});
		});
};
function adminGetkycActionTypesuccess(data) {
	return {
		type: ADMINGETKYCACTIONTYPE_SUCCESS,
		payload: data
	};
}
function adminGetkycActionTypeFailed(data) {
	return {
		type: ADMINGETKYCACTIONTYPE_FAILED,
		payload: data
	};
}

export { resetAdminGetkycActionType, adminGetkycActionType };
